<div class="glxy-event-type-table-header-button-component">
  <button
    mat-flat-button
    color="primary"
    *ngIf="selectedToggle === 'group' && groupPageLink$ | async as groupPagelink"
    (click)="navigateToGroups(groupPagelink)"
  >
    <mat-icon>add</mat-icon>
    {{ 'MEETING_SCHEDULER.MEETING_LIST.CREATE_GROUP_DESKTOP' | translate }}
  </button>
  <button
    mat-flat-button
    color="primary"
    *ngIf="selectedToggle === 'service' && servicePageLink$ | async as servicePagelink"
    (click)="navigateToGroups(servicePagelink)"
  >
    <mat-icon>add</mat-icon>
    {{ 'MEETING_SCHEDULER.MEETING_LIST.CREATE_SERVICE_DESKTOP' | translate }}
  </button>
  <div *ngIf="selectedToggle === 'events'" class="button-section">
    <glxy-button-group>
      <button mat-flat-button color="primary" [matMenuTriggerFor]="saveMenu">
        <mat-icon>add</mat-icon>
        {{ 'MEETING_SCHEDULER.MEETING_LIST.CREATE_EVENT_DESKTOP' | translate }}
      </button>
    </glxy-button-group>

    <mat-menu #saveMenu="matMenu">
      <ng-container *ngIf="personalCalendar$ | async as personalCalendar">
        <ng-container *ngIf="eventTypePageLink$ | async as eventTypePageLink">
          <button (click)="handleEventTableCreate(eventTypePageLink, personalCalendar.id)" mat-menu-item>
            {{ 'MEETING_SCHEDULER.MEETING_LIST.PERSONAL_EVENT_TYPE' | translate }}
          </button>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="groupCalendars$$ | async as groupCalendars">
        <ng-container *ngIf="groupCalendars.length > 0 && (eventTypePageLink$ | async) as eventTypePageLink">
          <button (click)="openSalesTeamDialog(eventTypePageLink, groupCalendars)" mat-menu-item>
            {{ 'MEETING_SCHEDULER.MEETING_LIST.TEAM_EVENT_TYPE' | translate }}
          </button>
        </ng-container>
      </ng-container>
    </mat-menu>
  </div>
</div>

@if ((dataSource.loading$ | async) === false && data.length === 0) {
  <glxy-empty-state class="no-data-info-card">
    <glxy-empty-state-hero>
      <img class="no-data-info-img" src="{{ noDataIcon }}" alt="NoTeam" />
    </glxy-empty-state-hero>
    <glxy-empty-state-title> {{ emptyStateTitle | translate }} </glxy-empty-state-title>
    <p>
      {{ emptyStateSubtitle | translate }}
    </p>
  </glxy-empty-state>
} @else {
  <glxy-table-container
    class="comprehensive-table"
    [dataSource]="dataSource"
    [columns]="columns$ | async"
    [showSelection]="false"
    [pageSizeOptions]="pageSizeOptions"
    [pageSize]="pageSize"
    [border]="false"
    [fullWidth]="false"
    [showFooter]="true"
    [displayOption]="this.displayOption()"
  >
    <glxy-table-content-header
      [showColumnArrange]="this.displayOption() === 'list'"
      [showFilters]="true"
      [showFiltersOpen]="false"
      [showFiltersApplied]="(dataSource.filtersApplied$ | async) ?? false"
      [showSearch]="true"
      [showSort]="false"
      [showExport]="false"
      [showActions]="false"
      [showDisplayToggle]="true"
      [display]="displayOption()"
      (displayChanges)="displayChanges($event)"
    >
      <div filters-area>
        <glxy-filter-chips
          [addFiltersHeader]="getFilterHeader(selectedToggle)"
          (filtersChanged)="onFilterChanged($event)"
        />
      </div>
    </glxy-table-content-header>
    <table #groupTable mat-table matSort (matSortChange)="sortData($event)">
      <tr mat-header-row *matHeaderRowDef="[]"></tr>

      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
          <glxy-table-selection />
        </th>
        <td mat-cell *matCellDef="let row">
          <glxy-table-selection [row]="row" />
        </td>
      </ng-container>

      <ng-container matColumnDef="isPinned">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row" [glxyTooltip]="'MEETING_SCHEDULER.MEETING_LIST.PIN_TO_TOP' | translate">
          <button mat-icon-button (click)="togglePin(row)">
            <mat-icon [ngClass]="{ 'disabled-icon': !row.isPinned, 'active-icon': row.isPinned }"> push_pin </mat-icon>
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ name | translate }}
        </th>
        <td mat-cell [glxyTooltip]="getTooltip(element.name, 30)" *matCellDef="let element">
          {{ element.name | truncate: 0 : 30 }}
        </td>
      </ng-container>

      <ng-container matColumnDef="eventCount">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ memberCount | translate }}
        </th>
        <td mat-cell *matCellDef="let element">{{ element.eventCount }}</td>
      </ng-container>

      <ng-container matColumnDef="teamName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'MEETING_SCHEDULER.MEETING_LIST.TABLE.VIEW.TEAM_NAME' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">{{ element.teamName }}</td>
      </ng-container>

      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'MEETING_SCHEDULER.MEETING_LIST.TABLE.VIEW.DESCRIPTION' | translate }}
        </th>
        <td mat-cell [glxyTooltip]="getTooltip(element.description, 30)" *matCellDef="let element">
          {{ element.description | truncate: 0 : 30 }}
        </td>
      </ng-container>

      <ng-container matColumnDef="eventType">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'MEETING_SCHEDULER.MEETING_LIST.TABLE.VIEW.CATEGORY' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">{{ element.eventType }}</td>
      </ng-container>

      <ng-container matColumnDef="duration">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'MEETING_SCHEDULER.MEETING_LIST.TABLE.VIEW.DURATION' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">{{ element.duration }}</td>
      </ng-container>

      <ng-container matColumnDef="bookingUrl">
        <th mat-header-cell *matHeaderCellDef>{{ 'MEETING_SCHEDULER.MEETING_LIST.TABLE.VIEW.LINK' | translate }}</th>
        <td mat-cell *matCellDef="let element">
          <div *ngIf="element.bookingUrl" class="link-cell">
            <a
              [href]="element.bookingUrl"
              target="_blank"
              rel="noopener noreferrer"
              class="booking-link"
              [glxyTooltip]="element.bookingUrl"
            >
              {{ element.bookingUrl | truncate: 8 : 40 }}
            </a>
            <button
              mat-icon-button
              (click)="copyToClipboard(element.bookingUrl)"
              aria-label="Copy link"
              [glxyTooltip]="'MEETING_SCHEDULER.MEETING_LIST.COPY_LINK' | translate"
            >
              <mat-icon class="copy-icon">content_copy</mat-icon>
            </button>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row" [glxyTooltip]="'MEETING_SCHEDULER.MEETING_LIST.MORE_OPTIONS' | translate">
          <button mat-icon-button [matMenuTriggerFor]="menu" (menuClosed)="onMenuClosed()">
            <mat-icon>more_vert</mat-icon>
          </button>

          <mat-menu #menu="matMenu">
            <a
              *ngIf="!row.isDefaultGroup"
              mat-menu-item
              (mouseenter)="onMenuItemHover($event)"
              (click)="handleView(row)"
              i18n="@@MEETING_SCHEDULER.MEETING_LIST.SETTINGS"
              class="meeting-type-menu-item"
            >
              <mat-icon>settings</mat-icon>
              {{ 'MEETING_SCHEDULER.MEETING_LIST.SETTINGS' | translate }}
            </a>
            <a
              *ngIf="row.isDefaultGroup"
              mat-menu-item
              (click)="navigateToEditURL(row.mid)"
              class="meeting-type-menu-item"
            >
              <mat-icon>settings</mat-icon>
              {{ 'MEETING_SCHEDULER.MEETING_LIST.EDIT_URL' | translate }}
            </a>
            <a
              mat-menu-item
              [href]="row.bookingUrl"
              i18n="@@MEETING_SCHEDULER.MEETING_LIST.VIEW_LINK"
              target="_blank"
              class="meeting-type-menu-item"
              (mouseenter)="onMenuItemHover($event)"
            >
              <mat-icon>launch</mat-icon>
              {{ 'MEETING_SCHEDULER.MEETING_LIST.VIEW_LINK' | translate }}
            </a>
            <button
              mat-menu-item
              [cdkCopyToClipboard]="row.bookingUrl"
              (click)="handleDeleteClicked(row.mid)"
              i18n="@@MEETING_SCHEDULER.MEETING_LIST.DELETE_LINK"
              class="meeting-type-menu-item"
              (mouseenter)="onMenuItemHover($event)"
              *ngIf="!row.isDefaultGroup"
            >
              <mat-icon>delete</mat-icon>
              {{ 'MEETING_SCHEDULER.MEETING_LIST.DELETE_LINK' | translate }}
            </button>
          </mat-menu>
        </td>
      </ng-container>

      <tr mat-row *matRowDef="let row; columns: []"></tr>
    </table>
    <mat-card
      glxy-grid-content
      appearance="outlined"
      glxyGridMinCardWidth="300"
      *glxyGridCard="let row"
      class="meeting-type-card"
    >
      <mat-card-header>
        <mat-icon *ngIf="row.isDefaultGroup" mat-card-avatar class="meeting-type-icon general-event-link-icon"
          >all_inclusive</mat-icon
        >
        <mat-icon
          *ngIf="!row.isDefaultGroup"
          mat-card-avatar
          class="meeting-type-icon"
          [style.background-color]="row.hexColor"
        >
          access_time
        </mat-icon>
        <mat-card-title
          [ngStyle]="selectedToggle !== 'events' && row.description === '-' ? { 'padding-top': '10px' } : {}"
          class="grid title-container"
          [glxyTooltip]="getTooltip(row.name, 30)"
        >
          {{ row.name | truncate: 0 : 30 }}
        </mat-card-title>
        <mat-card-subtitle
          *ngIf="selectedToggle !== 'events' && row.description !== '-'"
          class="grid"
          [glxyTooltip]="row.description"
          >{{ row.description }}</mat-card-subtitle
        >
        <mat-card-subtitle *ngIf="selectedToggle === 'events'">
          {{ row.duration }} - {{ row.eventType }} <span *ngIf="row.teamName !== '-'"> - {{ row.teamName }}</span>
        </mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <div class="button-container">
          <mat-menu #menu="matMenu">
            <a
              *ngIf="!row.isDefaultGroup"
              mat-menu-item
              (mouseenter)="onMenuItemHover($event)"
              (click)="handleView(row)"
              i18n="@@MEETING_SCHEDULER.MEETING_LIST.SETTINGS"
              class="meeting-type-menu-item"
            >
              <mat-icon>settings</mat-icon>
              {{ 'MEETING_SCHEDULER.MEETING_LIST.SETTINGS' | translate }}
            </a>
            <a
              *ngIf="row.isDefaultGroup"
              mat-menu-item
              (click)="navigateToEditURL(row.mid)"
              class="meeting-type-menu-item"
            >
              <mat-icon>settings</mat-icon>
              {{ 'MEETING_SCHEDULER.MEETING_LIST.EDIT_URL' | translate }}
            </a>
            <a
              mat-menu-item
              [href]="row.bookingUrl"
              i18n="@@MEETING_SCHEDULER.MEETING_LIST.VIEW_LINK"
              target="_blank"
              class="meeting-type-menu-item"
              (mouseenter)="onMenuItemHover($event)"
            >
              <mat-icon>launch</mat-icon>
              {{ 'MEETING_SCHEDULER.MEETING_LIST.VIEW_LINK' | translate }}
            </a>
            <button
              mat-menu-item
              [cdkCopyToClipboard]="row.bookingUrl"
              (click)="handleDeleteClicked(row.mid)"
              i18n="@@MEETING_SCHEDULER.MEETING_LIST.DELETE_LINK"
              class="meeting-type-menu-item"
              (mouseenter)="onMenuItemHover($event)"
              *ngIf="!row.isDefaultGroup"
            >
              <mat-icon>delete</mat-icon>
              {{ 'MEETING_SCHEDULER.MEETING_LIST.DELETE_LINK' | translate }}
            </button>
          </mat-menu>
          <button
            mat-stroked-button
            [matMenuTriggerFor]="menu"
            class="event-menu"
            [glxyTooltip]="'MEETING_SCHEDULER.MEETING_LIST.MORE_OPTIONS' | translate"
          >
            <mat-icon class="more-icon-style">more_vert</mat-icon>
          </button>

          <button
            mat-stroked-button
            (click)="copyToClipboard(row.bookingUrl)"
            [attr.aria-role]="'link'"
            [cdkCopyToClipboard]="row.bookingUrl"
            class="copy-event-button"
          >
            <mat-icon>content_copy</mat-icon>
            <span *ngIf="(isMobileScreen$ | async) === false">{{
              'MEETING_SCHEDULER.MEETING_LIST.COPY_LINK' | translate
            }}</span>
          </button>
        </div>
      </mat-card-content>
    </mat-card>
  </glxy-table-container>
}
